import type { ReactNode } from "react";
import { BrandMark } from "@/components/layout/brand-mark";
import { ThemeToggle } from "@/components/layout/theme-toggle";

interface VerificationShellProps {
	children: ReactNode;
}

export function VerificationShell({ children }: VerificationShellProps) {
	return (
		<div className="verification-shell">
			<header className="verification-shell__header">
				<BrandMark />
				<ThemeToggle />
			</header>
			<main className="verification-shell__content">
				<div className="verification-shell__card">{children}</div>
			</main>
		</div>
	);
}
